import React, { useEffect, useState, useRef } from 'react';
import './style.scss';
import { Header } from './download-center-header';
import {
  getDownloadCenterConfig,
  getDownloadCenterObject,
  getDownloadCenterDownload,
  getDownloadCenterDownloadStatus,
  cancelDownloadCenterDownload,
  getDownloadCenterNewsDetail,
} from '../../api/download';
import {
  IDownloadCenterConfig,
  IDownloadCenterObject,
  ISdkInfo,
  IVersionItem,
  IEngineJson,
  IPackage,
  IDownloadNews,
  DownloadTaskStep,
  IDownloadCenterDownload,
} from '../../model/api-modules/download-center';
import { DownloadSdkConfig } from './sdk-config';
import { DownloadModal } from './download-modal';
import { DownloadNewsModal } from './download-news-modal';
import classNames from 'classnames';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../components/message';
import {
  DownloadEngine,
  DownloadObjectType,
  DownloadPlatformType,
  IAPIGameItem,
} from '../../model/api-modules';
import {
  fetchGameList,
  getNewsList as getDownloadCenterNewsList,
} from '../../api';
import { formatStudioList } from '../game-content/lib';
import getFormatMessage from '../../locales/get-format-message';
import downloadListBg from '../../../src/assets/images/download-list-bg.png';
import downloadListEmpty from '../../../src/assets/images/download-list-empty.png';
import downloadClose from '../../../src/assets/svg/download-close.svg';
import downloadCloseActive from '../../../src/assets/svg/download-close-active.svg';
import { DownloadNews } from './download-news';
import { DownloadNewsList } from './download-news-list';
import { Footer } from '../component/footer';
import { NewsModule } from '../../model';

export const DownloadCenterRouter = () => {
  const [configList, setConfigList] = useState<IDownloadCenterConfig | null>(
    null
  );
  const [selectPlatform, setSelectPlatform] = useState<DownloadPlatformType[]>(
    []
  );
  const [objectList, setObjectList] = useState<IDownloadCenterObject[]>([]);
  const [abledPlatform, setAbledPlatform] = useState<DownloadPlatformType[]>(
    []
  );
  const [engineSelectData, setEngineSelectData] = useState<any>([]);
  const [selectSdk, setSelectSdk] = useState<number[]>([]);
  const [selectStudio, setSelectStudio] = useState<string | undefined>(
    undefined
  );
  const [selectGame, setSelectGame] = useState<string | undefined>(undefined);
  const [selectEnv, setSelectEnv] = useState<string | undefined>(undefined);
  const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);
  const [showDownloadNewsModal, setShowDownloadNewsModal] =
    useState<boolean>(false);
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);
  const [showProgressBar, setShowProgressBar] = useState<boolean>(false);
  const [progressBarNumber, setProgressBarNumber] = useState<number>(0);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [taskKey, setTaskKey] = useState<string>('');
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const taskProgressRef = useRef<number>(0);
  const [studioList, setStudioList] = useState<IAPIGameItem[]>([]);
  const [initNewsList, setInitNewsList] = useState<IDownloadNews[]>([]);
  const [newsAllList, setNewsAllList] = useState<IDownloadNews[]>([]);
  const [newsContent, setNewsContent] = useState<IDownloadNews | null>(null);
  const [showAllNewsList, setShowAllNewsList] = useState<boolean>(false);
  const [downloadTips, setDownloadTips] = useState<string>(
    'download_tips_fetching'
  );
  const [subVersionIDsList, setSubVersionIDsList] = useState<
    { id: number; subVersionTags: string[] }[]
  >([]);
  const checkRef = useRef<{ [key: number]: any }>({});

  useEffect(() => {
    initialization();
    getConfigList();
    getObjectList();
    getNewsList();
    window.addEventListener('click', () => setShowAllNewsList(false));
  }, []);

  const getNewsList = async () => {
    const res = await getDownloadCenterNewsList({
      page: 1,
      pageSize: 3,
      Module: String(NewsModule.DownloadCenter),
    });
    if (res?.list) {
      setInitNewsList(res.list);
    }
  };

  const getNewsAllList = async () => {
    const res = await getDownloadCenterNewsList({
      pageSize: 1000,
      Module: String(NewsModule.DownloadCenter),
    });
    if (res?.list) {
      setNewsAllList(res.list);
    }
  };

  const initialization = async () => {
    const res = await fetchGameList();
    if (res) {
      const studioData = formatStudioList(res);
      setStudioList(studioData);
    }
  };

  const getNewsDetail = async (id: number) => {
    const res = await getDownloadCenterNewsDetail(id);
    if (res) {
      setNewsContent(res);
      setShowDownloadNewsModal(true);
    }
  };

  useEffect(() => {
    const engineArray: any = [];
    const platformArray: DownloadPlatformType[][] = [];
    engineSelectData.forEach((item: any) => {
      if (item.type === DownloadObjectType.Client) {
        engineArray.push({
          id: item.id,
          engine: item.engine,
        });
      }
    });
    objectList.forEach((item) => {
      if (item.Type === DownloadObjectType.Client) {
        let isShow = false;
        if (item.StudioWhitelistArray.length !== 0) {
          item.StudioWhitelistArray.forEach((it) => {
            const studioItem = studioList.find(
              (studio) => studio.studioID === it
            );
            if (studioItem) {
              isShow = true;
            }
          });
        } else {
          isShow = true;
        }
        if (isShow) {
          const itemData = engineSelectData.find(
            (it: any) => it.id === item.id
          );
          const engineJson: IEngineJson[] =
            itemData.versionItem?.EngineJson || [];
          engineJson.forEach((engineJsonItem) => {
            const currentEngine = engineArray.find(
              (engineArrayItem: any) => engineArrayItem.id === item.id
            );
            if (currentEngine && engineJsonItem.type === currentEngine.engine) {
              platformArray.push(engineJsonItem.platform);
            }
          });
        }
      }
    });
    let platform: DownloadPlatformType[] = [];
    if (platformArray.length > 1) {
      platformArray.forEach((item) => {
        if (item.length !== 0) {
        }
        item.forEach((it) => {
          if (platform.indexOf(it) === -1) {
            platform.push(it);
          }
        });
      });
      // platform = platformArray.reduce(
      //   (prev: DownloadPlatform[], curr: DownloadPlatform[]) =>
      //     prev.filter((item: DownloadPlatform) => curr.includes(item))
      // );
    } else if (platformArray.length === 1) {
      platform = [...platformArray[0]];
    }
    setAbledPlatform(platform);
  }, [engineSelectData]);

  const getConfigList = async () => {
    const res = await getDownloadCenterConfig();
    if (res) {
      setConfigList(res);
    }
  };

  const getObjectList = async () => {
    const res = await getDownloadCenterObject();
    if (res) {
      const currentRes: IDownloadCenterObject[] = Object.assign([], res);
      const newRes: IDownloadCenterObject[] = currentRes.map((item) => {
        let newEngineJson = item.VersionItem?.EngineJson || [];
        if (
          item.VersionItem?.SubVersions &&
          item.VersionItem?.SubVersions.length !== 0
        ) {
          const typeMap: any = {};
          for (const it of item.VersionItem?.SubVersions) {
            const engineJson: any = it.EngineJson[0];
            if (!engineJson || typeof engineJson !== 'object') continue;

            const { type } = engineJson;

            if (!typeMap[type]) {
              typeMap[type] = { ...engineJson };
            } else {
              const existing = typeMap[type];
              for (const key in engineJson) {
                if (key === 'type' || key === 'package') {
                  continue;
                }

                const currentValue = engineJson[key];
                const existingValue = existing[key];

                if (currentValue === undefined || currentValue === null) {
                  continue;
                }

                if (Array.isArray(currentValue)) {
                  if (Array.isArray(existingValue)) {
                    const mergedArray = Array.from(
                      new Set([...existingValue, ...currentValue])
                    );
                    existing[key] = mergedArray;
                  } else {
                    existing[key] = Array.from(
                      new Set([...existingValue, ...currentValue])
                    ).filter(Boolean);
                  }
                } else {
                  if (existingValue === undefined) {
                    existing[key] = currentValue;
                  }
                }
              }
            }
          }
          newEngineJson = Object.keys(typeMap).map((i) => {
            return typeMap[i];
          });
        }
        return {
          ...item,
          VersionItem: {
            ...item.VersionItem,
            EngineJson: newEngineJson,
          },
        };
      });
      setObjectList(newRes);
      initEngineData(newRes);
    }
  };

  const initEngineData = (resData: IDownloadCenterObject[]) => {
    const engineData: any = [];
    resData.map((item) => {
      let engine = 0;
      let version = '';
      let pssdkVersion = '';
      let gdkVersion = '';
      if (item.Type === DownloadObjectType.Client) {
        engine =
          item.VersionItem && item.VersionItem.EngineJson?.length !== 0
            ? item.VersionItem.EngineJson[0].type
            : 0;
        version =
          (engine === DownloadEngine.UEPlugin ||
            engine === DownloadEngine.UnityPlugin) &&
          item.VersionItem?.EngineJson[0].version.length !== 0
            ? item.VersionItem?.EngineJson[0].version[0]
            : '';
        pssdkVersion =
          (engine === DownloadEngine.UEPlugin ||
            engine === DownloadEngine.UnityPlugin) &&
          item.VersionItem?.EngineJson[0].pssdkVersion.length !== 0
            ? item.VersionItem?.EngineJson[0].pssdkVersion[0]
            : '';
        gdkVersion =
          (engine === DownloadEngine.UEPlugin ||
            engine === DownloadEngine.UnityPlugin) &&
          item.VersionItem?.EngineJson[0].gdkVersion.length !== 0
            ? item.VersionItem?.EngineJson[0].gdkVersion[0]
            : '';
      } else if (item.Type === DownloadObjectType.Sample) {
        engine = DownloadEngine.Windows;
      } else if (item.Type === DownloadObjectType.Server) {
        engine = DownloadEngine.WinMsvC;
      } else if (item.Type === DownloadObjectType.Tools) {
        engine = DownloadEngine.Zip;
      }
      const currentPackage = item.VersionItem?.EngineJson[0]?.package || [];
      let size = 0;
      currentPackage.forEach((it) => {
        size += it.size;
      });
      engineData.push({
        versionItem: item.VersionItem,
        versionId: item.VersionItem?.id || 0,
        type: item.Type,
        id: item.id,
        engine,
        version,
        pssdkVersion,
        gdkVersion,
        size,
      });
      return engineData;
    });
    setEngineSelectData(engineData);
  };

  const onEngineDataChange = (
    id: number,
    key: string,
    value: number | string,
    versionItem?: IVersionItem
  ) => {
    const engineData: any = [];
    engineSelectData.map((item: any) => {
      if (item.id === id) {
        if (key === 'engine') {
          const currentEngine = item.versionItem?.EngineJson.find(
            (engine: any) => engine.type === value
          );
          const currentPackage: IPackage[] = currentEngine?.package || [];
          let size = 0;
          let version = '';
          let pssdkVersion = '';
          let gdkVersion = '';
          currentPackage.forEach((it) => {
            size += it.size;
          });

          version = currentEngine?.version?.[0] || '';

          pssdkVersion = currentEngine?.pssdkVersion?.[0] || '';
          gdkVersion = currentEngine?.gdkVersion?.[0] || '';

          engineData.push({
            ...item,
            engine: value,
            version,
            pssdkVersion,
            gdkVersion,
            size,
          });
        } else if (key === 'versionId') {
          let engine = 0;
          let version = '';
          let pssdkVersion = '';
          let gdkVersion = '';
          if (item.type === DownloadObjectType.Client) {
            engine =
              versionItem && versionItem.EngineJson?.length !== 0
                ? versionItem.EngineJson[0].type
                : 0;
            version =
              (engine === DownloadEngine.UEPlugin ||
                engine === DownloadEngine.UnityPlugin) &&
              versionItem &&
              versionItem?.EngineJson[0]?.version.length !== 0
                ? versionItem?.EngineJson[0].version[0]
                : '';
            pssdkVersion =
              (engine === DownloadEngine.UEPlugin ||
                engine === DownloadEngine.UnityPlugin) &&
              versionItem &&
              versionItem?.EngineJson[0]?.pssdkVersion.length !== 0
                ? versionItem?.EngineJson[0].pssdkVersion[0]
                : '';
            gdkVersion =
              (engine === DownloadEngine.UEPlugin ||
                engine === DownloadEngine.UnityPlugin) &&
              versionItem &&
              versionItem?.EngineJson[0]?.gdkVersion.length !== 0
                ? versionItem?.EngineJson[0].gdkVersion[0]
                : '';
          } else if (item.type === DownloadObjectType.Sample) {
            engine = DownloadEngine.Windows;
          } else if (item.type === DownloadObjectType.Server) {
            engine = DownloadEngine.WinMsvC;
          } else if (item.type === DownloadObjectType.Tools) {
            engine = DownloadEngine.Zip;
          }
          const currentPackage =
            versionItem?.EngineJson.find((it: any) => it.type === engine)
              ?.package || [];
          let size = 0;
          currentPackage.forEach((it) => {
            size += it.size;
          });
          engineData.push({
            ...item,
            versionItem,
            versionId: value,
            engine,
            version,
            pssdkVersion,
            gdkVersion,
            size,
          });
        } else {
          engineData.push({
            ...item,
            version: key === 'version' ? value : item.version,
            pssdkVersion: key === 'pssdkVersion' ? value : item.pssdkVersion,
            gdkVersion: key === 'gdkVersion' ? value : item.gdkVersion,
          });
        }
      } else {
        engineData.push(item);
      }
      return engineData;
    });
    setEngineSelectData(engineData);
    const checkInstance = checkRef.current[id];
    if (checkInstance?.checkItem) {
      checkInstance.checkItem(id, true, engineData);
    }
  };

  const onPlatformChange = (platforms: DownloadPlatformType[]) => {
    setSelectPlatform(platforms);

    engineSelectData?.forEach((clientSdk: any) => {
      const allEngine: IEngineJson[] = clientSdk?.versionItem?.EngineJson || [];

      if (allEngine.length <= 1) {
        return;
      }

      const engineInfo = allEngine.find(
        (engine: IEngineJson) => engine.type === clientSdk?.engine
      );

      const isMatch = platforms.every((platform) =>
        engineInfo?.platform.includes(platform)
      );

      if (!isMatch) {
        const matchedEngine = allEngine.find((engineInfo) => {
          return platforms.every((platform) =>
            engineInfo?.platform.includes(platform)
          );
        });
        if (matchedEngine) {
          onEngineDataChange(clientSdk.id, 'engine', matchedEngine.type);
        }
      }
    });
  };

  const renderDownloadNewsAllList = () => {
    if (showAllNewsList) {
      return (
        <DownloadNewsList
          newsAllList={newsAllList}
          getNewsDetail={getNewsDetail}
        />
      );
    }
    return null;
  };

  const renderBanner = () => {
    return (
      <div className="download-header">
        <Header />
        <div className="download-header-content">
          <div className="download-header-build">
            {getFormatMessage('build')}
          </div>
          <div className="download-header-better">
            {getFormatMessage('better_games')}
          </div>
          <div style={{ position: 'relative', width: '760px' }}>
            <DownloadNews
              initNewsList={initNewsList}
              getNewsDetail={getNewsDetail}
              showAllNewsList={showAllNewsList}
              setShowAllNewsList={setShowAllNewsList}
              getNewsAllList={getNewsAllList}
            />
            {renderDownloadNewsAllList()}
          </div>
        </div>
      </div>
    );
  };

  const renderConfigList = () => {
    if (configList) {
      const objectType = configList.ObjectType;
      const keys = Object.keys(objectType);
      return (
        <div style={{ width: '760px' }}>
          {keys.map((item) => {
            return (
              <DownloadSdkConfig
                configKey={item}
                selectPlatform={selectPlatform}
                setSelectPlatform={onPlatformChange}
                objectList={objectList}
                engineSelectData={engineSelectData}
                onEngineDataChange={onEngineDataChange}
                abledPlatform={abledPlatform}
                selectSdk={selectSdk}
                setSelectSdk={setSelectSdk}
                subVersionIDsList={subVersionIDsList}
                setSubVersionIDsList={setSubVersionIDsList}
                studioList={studioList}
                ref={checkRef}
              />
            );
          })}
        </div>
      );
    }
    return <div style={{ width: '760px' }}></div>;
  };

  const deleteDownloadItem = (id: number) => {
    const newSelectSdk = Object.assign([], selectSdk);
    if (newSelectSdk.indexOf(id) !== -1) {
      newSelectSdk.splice(newSelectSdk.indexOf(id), 1);
    }
    setSelectSdk(newSelectSdk);
  };

  const clickDownload = () => {
    if (selectSdk.length !== 0) {
      setShowDownloadModal(true);
      if (!isNeedSelectEnv()) {
        onDownloadOk(true);
      }
    }
  };

  const renderDownloadList = () => {
    let size = 0;
    let itemSizeContent = '0 GB';
    engineSelectData.forEach((it: any) => {
      if (selectSdk.indexOf(it.id) !== -1) {
        size += it.size;
      }
    });
    const newItemSize = Number((size / 1024).toFixed(1));
    if (size === 0) {
      itemSizeContent = '0 GB';
    } else if (newItemSize < 0.1) {
      itemSizeContent = `${size.toFixed(1)} MB`;
    } else {
      itemSizeContent = `${newItemSize} GB`;
    }
    return (
      <div className="download-list-box">
        <img src={downloadListBg} className="download-list-bg" />
        <div className="download-list-content">
          {selectSdk.length !== 0 ? (
            selectSdk.map((sdkItem) => {
              const objectItem = objectList.find((item) => item.id === sdkItem);
              if (objectItem) {
                const engineItem = engineSelectData.find(
                  (item: any) => item.id === objectItem.id
                );
                if (objectItem.Type === DownloadObjectType.Client) {
                  const engineData = engineSelectData.find(
                    (item: any) => item.id === sdkItem
                  );
                  const subItem = subVersionIDsList?.find(
                    (it) => it.id === objectItem.id
                  );
                  const subVersionTags = subItem ? subItem.subVersionTags : [];
                  let secondName = '';
                  subVersionTags?.length !== 0 &&
                    subVersionTags.forEach((it) => {
                      const subObjectItem = objectItem.SubObject?.find(
                        (i) => i.Tag === it
                      );
                      if (subObjectItem) {
                        secondName += `${subObjectItem.Name},`;
                      }
                    });
                  if (secondName) {
                    secondName = secondName.slice(0, -1);
                  }
                  if (engineData) {
                    return (
                      <div className="download-list-item">
                        <div className="download-item-title">
                          <div>
                            <span>{objectItem.Name}</span>
                            <span style={{ marginLeft: '4px' }}>
                              {engineItem.versionItem?.Version}
                            </span>
                          </div>
                          <img
                            src={downloadClose}
                            className={classNames(
                              'download-item-close',
                              'close-gray'
                            )}
                            onClick={() => deleteDownloadItem(objectItem.id)}
                          />
                          <img
                            src={downloadCloseActive}
                            className={classNames(
                              'download-item-close',
                              'close-active'
                            )}
                            onClick={() => deleteDownloadItem(objectItem.id)}
                          />
                        </div>
                        {secondName && (
                          <div className="download-item-second">
                            {getFormatMessage('include_second', {
                              params: {
                                name: secondName,
                              },
                            })}
                          </div>
                        )}
                        {engineData.version && (
                          <div className="download-item-version-title">
                            {engineData.engine === DownloadEngine.UEPlugin && (
                              <span>{getFormatMessage('ue_plugin')}</span>
                            )}
                            {engineData.engine ===
                              DownloadEngine.UnityPlugin && (
                              <span>{getFormatMessage('unity_plugin')}</span>
                            )}
                            <span>{engineData.version}</span>
                          </div>
                        )}
                        {engineData.pssdkVersion &&
                          (selectPlatform.indexOf(DownloadPlatformType.PS4) !==
                            -1 ||
                            selectPlatform.indexOf(DownloadPlatformType.PS5) !==
                              -1) && (
                            <div className="download-item-version-title">
                              <span>{getFormatMessage('ps_sdk')}</span>
                              <span>{engineData.pssdkVersion}</span>
                            </div>
                          )}
                        {engineData.gdkVersion &&
                          selectPlatform.indexOf(DownloadPlatformType.XSX) !==
                            -1 && (
                            <div className="download-item-version-title">
                              <span>{getFormatMessage('gdk')}</span>
                              <span>{engineData.gdkVersion}</span>
                            </div>
                          )}
                      </div>
                    );
                  }
                  return null;
                }
                return (
                  <div className="download-list-item">
                    <div className="download-item-title">
                      <div>
                        <span>{objectItem.Name}</span>
                        <span style={{ marginLeft: '4px' }}>
                          {engineItem.versionItem?.Version}
                        </span>
                      </div>
                      <img
                        src={downloadClose}
                        className={classNames(
                          'download-item-close',
                          'close-gray'
                        )}
                        onClick={() => deleteDownloadItem(objectItem.id)}
                      />
                      <img
                        src={downloadCloseActive}
                        className={classNames(
                          'download-item-close',
                          'close-active'
                        )}
                        onClick={() => deleteDownloadItem(objectItem.id)}
                      />
                    </div>
                  </div>
                );
              }
              return null;
            })
          ) : (
            <div>
              <img
                src={downloadListEmpty}
                className="download-list-empty-icon"
              />
              <div className="download-list-empty-text">
                {getFormatMessage('download_list_empty')}
              </div>
            </div>
          )}
        </div>
        <div className="download-list-compute-box">
          {/* {`${size} GB｜Approximate Download Time：XX min`} */}
          {`${itemSizeContent}`}
        </div>
        <div
          className={classNames(
            'download-btn',
            selectSdk.length === 0 ? 'download-btn-disabled' : ''
          )}
          onClick={() => clickDownload()}
        >
          {getFormatMessage('download_list_btn')}
        </div>
      </div>
    );
  };

  const intervalHandle = useRef<null | NodeJS.Timeout>(null);
  const taskInterval = useRef<null | NodeJS.Timeout>(null);

  const onDownloadOk = async (isNoStep?: boolean) => {
    if (!selectStudio && !isNoStep) {
      return messageWarning(getFormatMessage('please_select_studio'));
    }
    if (!selectGame && !isNoStep) {
      return messageWarning(getFormatMessage('please_select_game'));
    }
    if (!selectEnv && !isNoStep) {
      return messageWarning(getFormatMessage('please_select_env'));
    }
    setDownloadLoading(true);
    const sdkInfo: ISdkInfo[] = [];
    engineSelectData.length !== 0 &&
      engineSelectData.forEach((item: any) => {
        if (selectSdk.indexOf(item.id) !== -1) {
          const subItem = subVersionIDsList?.find((it) => it.id === item.id);
          const subVersionTags = subItem ? subItem.subVersionTags : [];
          sdkInfo.push({
            platforms: selectPlatform,
            versionID: item.versionId,
            engine: {
              type: item.engine,
              version: item.version,
              windowVersion: selectPlatform.includes(
                DownloadPlatformType.Windows
              )
                ? DownloadPlatformType.Windows.toString()
                : '',
              macosVersion: selectPlatform.includes(DownloadPlatformType.Mac)
                ? DownloadPlatformType.Mac.toString()
                : '',
              androidVersion: selectPlatform.includes(
                DownloadPlatformType.Android
              )
                ? DownloadPlatformType.Android.toString()
                : '',
              iosVersion: selectPlatform.includes(DownloadPlatformType.IOS)
                ? DownloadPlatformType.IOS.toString()
                : '',
              pssdkVersion:
                selectPlatform.indexOf(DownloadPlatformType.PS4) !== -1 ||
                selectPlatform.indexOf(DownloadPlatformType.PS5) !== -1
                  ? item.pssdkVersion
                  : '',
              gdkVersion:
                selectPlatform.indexOf(DownloadPlatformType.XSX) !== -1
                  ? item.gdkVersion
                  : '',
            },
            subVersionTags,
          });
        }
      });
    let body: IDownloadCenterDownload | null;
    if (isNoStep) {
      body = {
        SdkInfo: sdkInfo,
      };
    } else {
      body = {
        StudioID: selectStudio,
        GameID: selectGame,
        EnvID: Number(selectEnv),
        SdkInfo: sdkInfo,
      };
    }

    const res = await getDownloadCenterDownload({ ...body });

    if (!res) {
      if (isNoStep) {
        setShowDownloadModal(false);
      }
      setDownloadLoading(false);
      return messageError(getFormatMessage('download_failed'));
    }
    if (res?.taskKey) {
      setShowProgressBar(true);
      setTaskKey(res.taskKey);

      getTaskStatus(res.taskKey);
      intervalHandle.current = setInterval(() => {
        getTaskStatus(res.taskKey, isNoStep);
      }, 5000);
    }
    setDownloadLoading(false);
    return res;
  };

  const getTaskStatus = async (key: string, isNoStep?: boolean) => {
    const taskStatus = await getDownloadCenterDownloadStatus(key);
    if (intervalHandle.current && taskStatus) {
      if (taskStatus.status?.error) {
        messageError(`${taskStatus.status?.error?.type || 'Download'} error.`);
        clearInterval(intervalHandle.current);
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        setShowProgressBar(false);
        setTaskKey('');
        setDownloadTips('download_tips_fetching');
        setProgressBarNumber(0);
        taskProgressRef.current = 0;
        if (isNoStep) {
          setShowDownloadModal(false);
        }
        return;
      }
      if (taskStatus.status?.step === DownloadTaskStep.Initialization) {
        setDownloadTips('download_tips_fetching');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 12) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (taskStatus.status?.step === DownloadTaskStep.DownRemoteZip) {
        setDownloadTips('download_tips_fetching');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 12) {
          taskProgressRef.current = 12;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 24) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (taskStatus.status?.step === DownloadTaskStep.Unzip) {
        setDownloadTips('download_tips_unzipping');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 24) {
          taskProgressRef.current = 24;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 36) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (taskStatus.status?.step === DownloadTaskStep.WriteConfig) {
        setDownloadTips('download_tips_unzipping');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 36) {
          taskProgressRef.current = 36;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 48) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (taskStatus.status?.step === DownloadTaskStep.MakingPackage) {
        setDownloadTips('download_tips_unzipping');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 36) {
          taskProgressRef.current = 36;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 48) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (taskStatus.status?.step === DownloadTaskStep.MakeZip) {
        setDownloadTips('download_tips_generated');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 48) {
          taskProgressRef.current = 48;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 60) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (taskStatus.status?.step === DownloadTaskStep.UploadRemote) {
        setDownloadTips('download_tips_uploading');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 60) {
          taskProgressRef.current = 60;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 72) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (taskStatus.status?.step === DownloadTaskStep.PushCDNCache) {
        setDownloadTips('download_tips_cdn');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 72) {
          taskProgressRef.current = 72;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 84) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 1000);
      } else if (
        taskStatus.status?.step === DownloadTaskStep.DescribePushTask
      ) {
        setDownloadTips('download_tips_cdn');
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        if (taskProgressRef.current < 84) {
          taskProgressRef.current = 84;
        }
        taskInterval.current = setInterval(() => {
          if (taskProgressRef.current < 99) {
            taskProgressRef.current += 1;
            setProgressBarNumber(taskProgressRef.current);
          } else {
            taskInterval.current && clearInterval(taskInterval.current);
          }
        }, 3000);
      }
      if (taskStatus.status?.link) {
        setDownloadTips('download_tips_success');
        setProgressBarNumber(100);
        clearInterval(intervalHandle.current);
        if (taskInterval.current) {
          clearInterval(taskInterval.current);
        }
        taskStatus.status?.link.forEach((item: string) => {
          // window.open(item, '_blank');
          handleDownload(item);
        });
        console.log('下载成功', taskStatus.status.link);
      }
    }
  };

  const handleDownload = (link: string) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = link;
    document.body.appendChild(iframe);
  };

  const closeModal = () => {
    setSelectStudio(undefined);
    setSelectGame(undefined);
    setSelectEnv(undefined);
    setShowDownloadModal(false);
    setDownloadTips('download_tips_fetching');
  };

  const onClose = () => {
    if (!showProgressBar && isNeedSelectEnv()) {
      closeModal();
    } else {
      if (progressBarNumber === 100) {
        closeModal();
        setShowProgressBar(false);
        setTaskKey('');
        setProgressBarNumber(0);
        taskProgressRef.current = 0;
      } else {
        setShowConfirmModal(true);
      }
    }
  };

  const isNeedSelectEnv = () => {
    const needConfirmObjects = objectList.filter((item) =>
      ['InGame GaaS SDK', 'InGame SDK', 'InGame Tool'].includes(item.Name)
    );
    const needConfirmObjectIds = needConfirmObjects.map((item) => item?.id);
    return needConfirmObjectIds.some((id) => selectSdk.includes(id));
  };

  const onSecondaryConfirmation = async () => {
    setConfirmLoading(true);

    const res = await cancelDownloadCenterDownload(taskKey);
    if (res) {
      if (!isNeedSelectEnv()) {
        setShowDownloadModal(false);
      }
      setDownloadTips('download_tips_fetching');
      setShowConfirmModal(false);
      setShowProgressBar(false);
      setTaskKey('');
      taskProgressRef.current = 0;
      setProgressBarNumber(0);
      intervalHandle.current && clearInterval(intervalHandle.current);
      taskInterval.current && clearInterval(taskInterval.current);
      messageSuccess(getFormatMessage('cancel_download_success'));
    } else {
      messageError(getFormatMessage('cancel_download_failed'));
    }
    setConfirmLoading(false);
    return res;
  };

  const renderDownloadModal = () => {
    if (showDownloadModal) {
      return (
        <DownloadModal
          onClose={onClose}
          selectStudio={selectStudio}
          setSelectStudio={setSelectStudio}
          selectGame={selectGame}
          setSelectGame={setSelectGame}
          selectEnv={selectEnv}
          setSelectEnv={setSelectEnv}
          downloadLoading={downloadLoading}
          onDownloadOk={onDownloadOk}
          showProgressBar={showProgressBar}
          progressBarNumber={progressBarNumber}
          showConfirmModal={showConfirmModal}
          setShowConfirmModal={setShowConfirmModal}
          onSecondaryConfirmation={onSecondaryConfirmation}
          confirmLoading={confirmLoading}
          selectSdk={selectSdk}
          objectList={objectList}
          downloadTips={downloadTips}
        />
      );
    }
  };

  const onKnow = () => {
    setShowDownloadNewsModal(false);
    setNewsContent(null);
  };

  const renderDownloadNewsModal = () => {
    if (showDownloadNewsModal && newsContent) {
      return <DownloadNewsModal newsContent={newsContent} onKnow={onKnow} />;
    }
    return null;
  };

  return (
    <div className="download-center">
      {renderBanner()}
      <div className="download-content">
        {renderConfigList()}
        {renderDownloadList()}
      </div>
      {renderDownloadModal()}
      {renderDownloadNewsModal()}
      <Footer />
    </div>
  );
};
